import { constants, mediaQueryStyles } from "@newsela/angelou";

import fontStyleBuilder from "@/challenges/utils/fontStyleBuilder";

const { ui } = constants.colors;

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { sm },
} = constants.breakpoints;

const neutral700 = ui.neutral[700];
const neutral600 = ui.neutral[600];
const neutral100 = ui.neutral[100];
const grey = ui.neutral[500];
const white500 = ui.white[500];

export const ACTIVITIES_CONTENT = "ACTIVITIES_CONTENT";

export const challengeDetailCardBadgesContentCss = (content) => ({
  display: "flex",
  flexDirection: content === ACTIVITIES_CONTENT ? "row" : "column",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: content === ACTIVITIES_CONTENT ? "16px 0" : "16px 0 6px 0",
  borderBottom: "1px solid rgb(29,29,29,.16)",
  h5: {
    margin: "0",
    color: neutral600,
    ...fontStyleBuilder({
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "178%",
    }),
  },
});

export const challengeDetailCardBadgesTitleCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "4px",
  width: "80%",
};

export const challengeDetailCardCss = {
  width: "100%",
  minWidth: "272px",
  backgroundColor: white500,
  transition: "box-shadow 0.3s ease-in-out",
  borderRadius: 16,
  border: `1px solid ${neutral100}`,
  "&:hover": {
    cursor: "pointer",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 8px 8px 2px",
  },
};

export const challengeDetailCardContentCss = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "100%",
  padding: "16px",
};

export const challengeDetailCardTitle = {
  width: "100%",
  margin: "8px 0 8px 0",
  color: neutral700,
  ...fontStyleBuilder({
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "120%",
  }),
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

export const challengeDetailHeaderCss = {
  position: "relative",
  backgroundColor: neutral600,
  borderTopRightRadius: "16px",
  borderTopLeftRadius: "16px",
};

export const buttonWrapper = {
  display: "block",
  width: "100%",
  justifyContent: "center",
};

export const cardHeaderBackgroundCss = {
  width: "100%",
  height: "162px",
  borderTopRightRadius: "16px",
  borderTopLeftRadius: "16px",

  [mq.downTo(sm)]: {
    height: "200px",
  },
};

export const descriptionChallengeTextCss = {
  width: "100%",
  color: neutral600,
  margin: 0,
  textOverflow: "ellipsis",
  ...fontStyleBuilder({
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "178%",
  }),
};

export const exploreTopicButtonCss = {
  display: "flex",
  width: "100%",
  justifyContent: "center",
  borderRadius: "8px",
};

export const finalScoresCss = {
  color: neutral600,
  ...fontStyleBuilder({
    fontSize: "16px",
    fontWeight: "700",
    lineHeight: "100%",
  }),
};

export const metaCss = {
  display: "flex",
  p: {
    margin: "0px",
    padding: "0px 8px",
    borderRight: "solid",
    borderColor: "rgba(51, 51, 51, 0.3)",
    color: grey,
  },
  "& > p:first-of-type": {
    paddingLeft: "0px",
  },
  "& > p:last-of-type": {
    border: "none",
  },
};

export const possibleTokensNumberCss = {
  color: neutral600,
  ...fontStyleBuilder({
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "120%",
  }),

  [mq.upTo(sm)]: {
    ...fontStyleBuilder({
      fontSize: "15px",
      fontWeight: "700",
      lineHeight: "120%",
    }),
  },
};

export const possibleTokensTextCss = {
  ...possibleTokensNumberCss,
  marginTop: "2px",
  ...fontStyleBuilder({
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "133%",
  }),

  [mq.upTo(sm)]: {
    ...fontStyleBuilder({
      fontSize: "10px",
      fontWeight: "400",
      lineHeight: "133%",
    }),
  },
};

export const possibleTokensContainer = {
  position: "absolute",
  display: "flex",
  alignItems: "center",
  padding: "4px 8px",
  backgroundColor: white500,
  border: `2px solid ${neutral100}`,
  borderTopRightRadius: "4px",
  borderTopLeftRadius: "4px",
  left: "16px",
  bottom: "0px",
};

export const possibleTokensTeacherHome = {
  display: "flex",
  alignItems: "center",
};

export const topicRowCss = {
  margin: "24px 0 20px",
  width: "100%",
};

export const metaText = {
  margin: "0px",
  padding: "0px 8px",
  borderRight: "solid",
  borderColor: "rgba(51, 51, 51, 0.3)",
  color: grey,
};
